import moment from "moment";

export const VersionColumns = (expandRow, setExpandRow) => [
  {
    dataField: "type",
    text: "type",
    formatter: (cell, row) => {
      return <span className="tb-data minWidth100">{row?.type || "NA"}</span>;
    },
  },
  {
    dataField: "wtf_version",
    text: "WTF Version",
    formatter: (cell, row) => {
      return (
        <span className="tb-data minWidth100">{row?.wtf_version || "NA"}</span>
      );
    },
  },
  {
    dataField: "google_version",
    text: "Google Version",
    formatter: (cell, row) => {
      return (
        <span className="tb-data minWidth100">
          {row?.google_version || "NA"}
        </span>
      );
    },
  },
  {
    dataField: "apple_version",
    text: "Apple Version",
    formatter: (cell, row) => {
      return (
        <span className="tb-data minWidth100">
          {row?.apple_version || "NA"}
        </span>
      );
    },
  },
  {
    dataField: "force_update",
    text: "Force Update",
    formatter: (cell, row) => {
      return (
        <span className="tb-data minWidth100">
          {row?.force_update === 1 ? "Yes" : "No"}
        </span>
      );
    },
  },
  {
    dataField: "description",
    text: "Description",
    formatter: (cell, row) => {
      const maxLines = 3;

      return (
        <div
          className="tb-data"
          style={{
            position: "relative",
            textAlign: "center",
            maxWidth: "250px",
            minWidth: "100%",
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: expandRow === row?.uid ? "unset" : maxLines,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // width: "100%",
              // backgroundColor: "#f2f",
            }}
          >
            <span
              dangerouslySetInnerHTML={{ __html: row?.description || "NA" }}
            />
          </div>
          {row?.description?.split(" ").length > 20 && (
            <span
              onClick={() =>
                setExpandRow(() => {
                  if (expandRow === row?.uid) {
                    return "";
                  } else {
                    return row?.uid;
                  }
                })
              }
              style={{
                color: "blue",
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              {expandRow === row?.uid ? "Read Less" : "Read More"}
            </span>
          )}
        </div>
      );
    },
  },
  {
    dataField: "date_added",
    text: "Date Added",
    formatter: (cell, row) => {
      return (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateWithTimeZone(row.date_added) : ""}
        </span>
      );
    },
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (cell, row) => {
      return (
        <span
          // className="tb-data minWidth100"
          style={{
            width: "8px",
            height: "8px",
            padding: "5px",
            color: "#fff",
            borderRadius: "5px",
            fontSize: "14px",
            backgroundColor:
              row?.status.toLowerCase() === "active"
                ? "#28a745"
                : row?.status.toLowerCase() === "inactive"
                ? "#dc3545"
                : "#000",
          }}
        >
          {row?.status || "NA"}
        </span>
      );
    },
  },
];

export const AppOptions = [
  { label: "Member App", value: "member" },
  { label: "Guru App", value: "guru" },
  { label: "TV App", value: "tv" },
];

export const formatDateWithTimeZone = (timestamp) => {
  if (!timestamp) return "Invalid date"; // Handle empty or undefined input
  return moment(parseInt(timestamp)).format("DD MMMM YYYY hh:mm A");
};
